import React, { useState } from 'react';
import SearchBar from './SearchBar';
import ReactLoading from 'react-loading';
import ItemList from './ItemList';
import PropTypes from 'prop-types';
import './Gift.css';

function Gift({post, setItemGives, onClick, onGive, setChangeItemIconColor, socket, setseenGifts, onItemClick}) {
  const [items, setItems] = useState([]);
  const [searched, setSearched] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  
  const searchStarted = () => {
    setSearched(true);
    setIsLoading(true);
  }
  
  const handleSearch = (searchResults) => {
    setItems(searchResults);
    setIsLoading(false);
  };

  return (
    <div className='gift-container' onClick={onClick}>
      <SearchBar onSearch={handleSearch} searchStarted={searchStarted}/>
      {searched && (
          isLoading ? (
          <ReactLoading type={'balls'} color={'white'} height={'20%'} width={'20%'} />
        ) : (
          <ItemList 
            items={items} 
            post={post} 
            setItemGives={setItemGives} 
            onGive={onGive}
            socket={socket}
            onItemClick={onItemClick}
            setChangeItemIconColor={setChangeItemIconColor}
            setseenGifts={setseenGifts}
            setIsLoading={setIsLoading}
          />
        )
      )}
      </div>
  );
}

export default Gift;

Gift.propTypes = {
  post: PropTypes.object,
  setItemGives: PropTypes.func,
  onClick: PropTypes.func,
  onGive: PropTypes.func,
  socket: PropTypes.object,
  setChangeItemIconColor: PropTypes.func,
  onItemClick: PropTypes.func,
  setseenGifts: PropTypes.func
};

// needed for the createlink component that does not need these props
Gift.defaultProps = {
  post: null,
  setItemGives: () => {},
  onClick: () => {},
  onGive: () => {},
  socket: null,
};
